import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { withTranslation } from 'react-i18next';
import WidgetDropdownList from 'react-widgets/lib/DropdownList';
import { DropdownList as FormControlDropdownList } from '../../common/components/formControls';
import { WithClearableSelection } from '../../common/components/formControls/DropdownList';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { loadUnpagedTerms, getDefaultActiveTerm, getLastTerm } from './actions';
import ui from '../../common/services/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const DefaultSelectionMode = {
	NONE: 'none',
	ACTIVE: 'active'		// select active term on initial load
};

const RenderMode = {
	CONTROL: 'control',
	FIELD: 'field',			// render as redux-form field
	BUTTON: 'button'
};

const termItemComponent = ({ item }) => (
	<span className={item && item.active ? 'term-active' : ''}>
		{item && item.name}{item && item.startDate ? ` (${ui.formatShortDate(item.startDate)} - ${ui.formatShortDate(item.endDate)})` : ''}
	</span>
);

const termValueComponent = ({ item }) => item
	? <span>{item.name}</span>
	: null;

class DropdownList extends Component {
	constructor(props) {
		super(props);
		this.handleSelectChange = this.handleSelectChange.bind(this);
	}

	componentDidMount() {
		//this.props.loadUnpagedTerms();
	}

	componentWillReceiveProps(nextProps) {
		const { onChange, value, defaultSelectedId } = nextProps;

		// trigger onChange if dropdown value is set to Active term on initial load
		if (value == null && defaultSelectedId && onChange) {
			onChange(defaultSelectedId);
		}
	}

	handleSelectChange(selectedId) {
		const { onChange } = this.props;
		if (onChange) {
			onChange(selectedId);
		}
	}

	render() {
		// editableOnly is consumed by mapStateToProps and must not reach the widget
		const { render = RenderMode.CONTROL, data, defaultSelection = DefaultSelectionMode.NONE,
			name, value, defaultValue, onChange, hideEmptyOption, emptyLabel, editableOnly,
			defaultSelectedId, loadUnpagedTerms, activeTerm, t, tReady, i18n, ...rest } = this.props;

		const orderedData = data.slice().sort((a, b) => new Date(a.startDate) > new Date(b.startDate) ? -1 : 1);
		const selectedId = value || defaultSelectedId;
		const selected = selectedId && data.find(x => x.id === selectedId);

		switch (render) {
			case RenderMode.FIELD:
				return <Field name={name || 'termId'}
					component={FormControlDropdownList}
					options={orderedData}
					filter='contains'
					textField='name'
					valueField='id'
					placeholder={emptyLabel}
					itemComponent={termItemComponent}
					valueComponent={termValueComponent}
					clearable={!hideEmptyOption}
					defaultSelectedId={defaultSelectedId}
					{...rest} />;
			case RenderMode.BUTTON:
				return <Dropdown>
					<Dropdown.Toggle title={<span>{(selected && selected.name) || emptyLabel} <FontAwesomeIcon icon={faChevronDown} /></span>} noCaret {...rest} />
					<Dropdown.Menu className='dashboard-dropdown-menu'>
						{hideEmptyOption || <MenuItem key={0} eventKey='' onSelect={this.handleSelectChange}><span>{emptyLabel}</span></MenuItem>}
						{orderedData.map(term => {
							const isActive = term.active;
							return <MenuItem key={term.id} eventKey={term.id} onSelect={this.handleSelectChange}>
								<span className={isActive ? 'term-active' : ''}>{term.name}</span>
							</MenuItem>;
						})}
					</Dropdown.Menu>
				</Dropdown>;
			case RenderMode.CONTROL:
			default: {
				const currentValue = value != null ? value : defaultSelectedId;
				const currentItem = currentValue ? orderedData.find(term => term.id === currentValue) : null;
				const clearable = !hideEmptyOption;
				const valueComponentForControl = clearable
					? WithClearableSelection(() => this.handleSelectChange(''), termValueComponent, false)
					: termValueComponent;
				return <WidgetDropdownList
					className='term-dropdown-control'
					data={orderedData}
					filter='contains'
					textField='name'
					valueField='id'
					placeholder={emptyLabel || (t && t('Common_Select'))}
					itemComponent={termItemComponent}
					valueComponent={valueComponentForControl}
					value={currentItem || null}
					onChange={item => this.handleSelectChange(item ? item.id : '')}
					{...rest}
				/>;
			}
		}
	}
}

const mapStateToProps = (state, ownProps) => {
	const allTerms = state.entities.terms;
	const lastTerm = getLastTerm(allTerms);
	const activeTerm = getDefaultActiveTerm(allTerms);
	const defaultSelectedId = ownProps.defaultSelection === DefaultSelectionMode.ACTIVE &&
		(activeTerm && activeTerm.id.toString() || lastTerm && lastTerm.id.toString());
	const schoolYearId = ownProps.schoolYearId;
	const centerId = ownProps.centerId;
	let terms = Object.values(allTerms);
	if (schoolYearId) {
		terms = terms.filter(term => term.schoolYearId === schoolYearId);
	}
	if (centerId) {
		terms = terms.filter(term => !term.centerId || term.centerId === centerId);
	}
	// opt-in: restricted users can only manage records for terms tied to one of their centres,
	// so terms without a center are dropped from screens that create/edit such records
	const currentUser = state.auth.currentUser || {};
	if (ownProps.editableOnly && (currentUser.isCenterRestricted || currentUser.isFranchiseeRestricted)) {
		terms = terms.filter(term => !!term.centerId);
	}
	return {
		data: terms,
		activeTerm,
		defaultSelectedId
	};
};

export default connect(mapStateToProps, {
	loadUnpagedTerms
})(withTranslation()(DropdownList));
